var anim8 = module.exports = function (el, method) {
	var answer = el
	try {
		var x = module.exports[method](el)
		answer = x
	}
	catch (e) {}
	return answer
}
anim8.hide = function (el) {
	el.style.display = 'none'
	return el
}
anim8.show = function (el) {
	el.style.display = ''
	return el
}
anim8.fadeIn = function (el) {
	el.style.opacity = 0

	var last = +new Date()
	var tick = function () {
		el.style.opacity = +el.style.opacity + (new Date() - last) / 400
		last = +new Date()

		if (+el.style.opacity < 1) {
			(window.requestAnimationFrame && requestAnimationFrame(tick)) || setTimeout(tick, 16)
		}
	}

	tick()
}
